// extracted by mini-css-extract-plugin
module.exports = {"detailRow":"style_detailRow__3EAsx","iconBox":"style_iconBox__3mI0M","detailText":"style_detailText__XAtf4"};